//import { isLangEn } from "utils/translation/i18n"

/**
 * format the number as dd,ddd.dd
 * @param {Number} number
 */
const formatNumber = (number, isInteger = false) =>
  Number(number).toLocaleString(
    // isLangEn() ? "en-US" : "ar-EG", // TODO: fix arabic num problem
    //"en-US",
    !isInteger
      ? {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
      : {}
  )

export default formatNumber